import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from './keys'
import {representativeHostsChannelsV3} from '../services/representative.http'
import {useEffect} from 'react'
import {useRootStore} from '@/store'
import {selectChatStore} from '@/store/selectors'

export const useGetRepresentativeHostsChannelsV3 = (enabled = true) => {
    const {needReInitAfterNotification, setNeedReInitAfterNotification} = useRootStore(selectChatStore)
    const query = useQuery({
        queryKey: [QUERY_KEYS.representativeHostsChannelsV3],
        queryFn: representativeHostsChannelsV3,
        enabled
    })

    useEffect(() => {
        if (needReInitAfterNotification && enabled) {
            query.refetch()
            setNeedReInitAfterNotification(false)
        }
    }, [needReInitAfterNotification])

    return query
}
